<template>
  <div class="animated fadeIn">
    <i
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <v-btn elevation="6" outlined small>n</v-btn> ساخت آیتم جدید

          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />

    <v-col lg="12" class="ml-auto"></v-col>

    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <b-btn
          @click="openNewItemDialog(type)"
          v-shortkey.once="['n']"
          @shortkey="openNewItemDialog(type)"
          class="btn-dark float-left my-2"
          >+ ثبت {{ type.name }} جدید +</b-btn
        >
        <h5 class="m-0 pt-1">کل {{ type.name }}</h5>
      </template>
      <loading v-if="vLoading" />
      <br />
      <b-card class="shadow bc-white rounded">
        <v-row class="p-0">
          <v-col cols="12">
            <v-text-field
              clearable
              v-model="filter"
              id="filterInput"
              placeholder="جستجو"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <vue-excel-xlsx
          :data="items"
          class="darkGreen-mainBtn float-start my-4"
          style="width: 135px; height: 35px;"
          :class="items.length ? 'white--text' : 'disabled-excel'"
          :columns="excelFields"
          :file-name="'مواد اولیه'"
          :sheet-name="' مواد اولیه'"
        >
            <v-icon
              class="me-1"
              :class="items.length ? 'white--text' : ''"
            >
              mdi-file-excel-outline
            </v-icon>
            خروجی اکسل
        </vue-excel-xlsx>

        <v-btn
          :disabled="gettingReceipt || !items.length"
          class="darkRed-mainBtn white--text float-end my-4"
          @click="printReceipt()"
          depressed
          style="width: 135px; height: 35px;"
          ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
        >

        <b-table
          responsive
          show-empty
          id="itemsTable"
          :items="items"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :current-page="currentPage"
          :per-page="perPage"
          :busy="isBusy"
          :filter="filter"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>

          <template v-slot:cell(operation)="row">
            <!-- <b-button
              v-if="row.item._showDetails"
              variant="danger"
              @click="row.toggleDetails"
              >بستن
            </b-button>
            <b-button v-else variant="primary" @click="row.toggleDetails"
              >عملیات
            </b-button> -->
            <b-button
              class="mr-1"
              variant="success"
              @click="openEditDialog(row.item)"
              >ویرایش
            </b-button>
            <b-button
              class="mr-1"
              variant="warning"
              @click="openChangeInventoryDialog(row.item)"
              >رسید / حواله
            </b-button>
          </template>
          <template #row-details="row">
            <div
              class="animated fadeIn"
              style="text-align: center; vertical-align: middle"
            >
              <!-- <b-button
                class="mr-1"
                variant="primary"
                @click="openDetailDialog(row.item)"
                >جزییات
              </b-button> -->
              <b-button
                class="mr-1"
                variant="success"
                @click="openEditDialog(row.item)"
                >ویرایش
              </b-button>
              <b-button
                class="mr-1"
                variant="warning"
                @click="openChangeInventoryDialog(row.item)"
                >تغییر موجودی
              </b-button>
            </div>
          </template>

          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <template v-slot:cell(identifierFa)="data">
            <div style="text-align: center; vertical-align: middle">
              <a
                :href="'/warehouse/' + type.slug + '/' + data.item.id"
                target="_blank"
                >{{ data.value }}</a
              >
            </div>
          </template>
          <template v-slot:cell(inventory)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.item.inventory }} {{ data.item.measurementUnit }}
            </div>
          </template>
          <template v-slot:cell(identifierEn)="data">
            <div style="text-align: center; vertical-align: middle">
              <a
                :href="'/warehouse/' + type.slug + '/' + data.item.id"
                target="_blank"
                >{{ data.value }}</a
              >
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="items.length"
          :per-page="perPage"
          aria-controls="itemsTable"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
    </b-card>
    <v-dialog v-model="changeInventoryDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>تغییر موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="changeInventory-btn mt-3">
            <v-btn color="success" class="mb-4" @click="openEntryDialog()"
              >رسید - افزایش موجودی</v-btn
            >
            <v-btn color="red" class="text-light mb-4" @click="openExitDialog()"
              >حواله – کاهش موجودی</v-btn
            >
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="entryDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>رسید - افزایش موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group label="تاریخ ورود">
              <date-picker v-model="entry.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group label="ساعت ورود">
              <date-picker
                v-model="entry.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <v-select
              label="انبار مقصد"
              :items="warehouses"
              v-model="entry.warehouse"
              outlined
              dense
              item-text="name"
              item-value="id"
            />
            <v-text-field
              outlined
              dense
              label="حجم ورودی"
              v-model="entry.number"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="مبدا"
              v-model="entry.origin"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="entry.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="entryDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="entrySubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exitDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>حواله - کاهش موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group label="تاریخ خروج">
              <date-picker v-model="exit.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group label="ساعت ورود">
              <date-picker
                v-model="exit.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <v-select
              label="انبار مبدا"
              :items="warehouses"
              v-model="exit.warehouse"
              outlined
              dense
              item-text="name"
              item-value="id"
            />
            <v-text-field
              outlined
              dense
              label="حجم خروجی"
              v-model="exit.number"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="مقصد"
              v-model="exit.origin"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="exit.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="exitDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="exitSubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="شرح فارسی *"
              v-model="selected2.identifierFa"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="شرح انگلیسی *"
              dir="ltr"
              v-model="selected2.identifierEn"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="نام"
              v-model="selected2.name"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="selected2.material"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="واحد اندازه‌گیری"
              v-model="selected2.measurementUnit"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="selected2.coating"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="selected2.dimensionStandard"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="selected2.diameter"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="selected2.length"
            ></v-text-field>

            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="selected2.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeEditModal()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="editItem()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newItemDialog" max-width="600px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>ثبت جدید</h4>
          <v-spacer></v-spacer>
          <v-btn
            class="text-white m-1"
            color="red"
            @click="newItemDialog = false"
          >
            لغو
          </v-btn>
          <v-btn color="success m-1" @click="addItem()"> ثبت </v-btn>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="شرح فارسی *"
              v-model="newItem.identifierFa"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="شرح انگلیسی *"
              dir="ltr"
              v-model="newItem.identifierEn"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="نام"
              v-model="newItem.name"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="newItem.material"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="newItem.coating"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="newItem.dimensionStandard"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="newItem.diameter"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="newItem.length"
            ></v-text-field>

            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="newItem.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="newItemDialog = false">
            لغو
          </v-btn>
          <v-btn color="success" @click="addItem()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>جزییات</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <br />
            <ul>
              <li v-for="field in fieldsFull" :key="field.key">
                <strong>{{ field.label }}:</strong> {{ info[field.key] }}
              </li>
            </ul>
            <table width="100%" border="1px">
              <tbody>
                <tr v-for="field in fieldsFull" :key="field.key">
                  <td style="text-align: center">
                    <strong>{{ field.label }}</strong>
                  </td>
                  <td style="text-align: center">{{ info[field.key] }}</td>
                </tr>
              </tbody>
            </table>

            <b-table
              responsive
              show-empty
              id="detailsTable"
              :items="info.exchanges"
              :fields="exchangesFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy2"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="info.exchanges ? info.exchanges.length : 0"
              :per-page="perPage"
              aria-controls="detailsTable"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
            <br />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="advanceFilter" max-width="600px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>فیلتر پیشرفته</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="adFilter.material"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="adFilter.coating"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="adFilter.dimensionStandard"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="adFilter.diameter"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="طول"
              v-model="adFilter.length"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="adFilter.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="delFilter()">
            حذف فیلتر
          </v-btn>
          <v-btn color="primary" @click="advanecFilter()"> جستجو</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <router-view></router-view>
    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">مواد اولیه</h3>
      <b-table :items="items" :fields="printFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Var from "../../../variables"; // NOTE (IMPORT) to transfer variables from a special file of variables

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    
  },
  data: function () {
    return {
      guide: false,
      type: Var.allTypes[1],
      printInvoice: {},
      gettingReceipt: false,
      items: [],
      warehouses: [],
      changeInventoryDialog: false,
      entryDialog: false,
      exitDialog: false,
      transferDialog: false,
      editDialog: false,
      newItemDialog: false,
      detailDialog: false,
      advanceFilter: false,
      adFilter: {},
      info: [],
      selected: "",
      selected2: [],
      entry: {},
      exit: {},
      transfer: {},
      edit: {},
      newItem: {},
      check: {
        name: false,
        material: false,
        coating: false,
        standard: false,
        diameter: false,
        length: false,
        number: false,
        description: false,
      },
      moment: moment,
      showProgress: false,
      items: [],
      filterOpt: [
        { key: "all", label: "همه" },
        { key: "exist", label: "اقلام دارای موجودی" },
        { key: "none", label: "اقلام بدون موجودی" },
      ],
      filter: null,
      fields: [
        { key: "index", label: "ردیف" },
        // { key: "identifierFa", label: "شرح فارسی" },
        { key: "identifierEn", label: "شرح" },
        { key: "inventory", label: "موجودی" },
        { key: "operation", label: "عملیات" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "identifierEn", label: "شرح" },
        { key: "inventory", label: "موجودی" },
      ],
      excelFields: [
        { field: "identifierEn", label: "شرح" },
        { field: "inventory", label: "موجودی" },
      ],
      fieldsFull: [
        { key: "identifierFa", label: "شرح فارسی" },
        { key: "identifierEn", label: "شرح انگلیسی" },
        { key: "name", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "number", label: "موجودی" },
        { key: "description", label: "توضیحات" },
        { key: "alertRange", label: "بازه اخطار" },
        { key: "crisisRange", label: "بازه بحران" },
        { key: "expireDate", label: "تاریخ انقضا" },
        { key: "measurementUnit", label: "واحد اندازه‌گیری" },
        { key: "warehouseName", label: "انبار" },
        { key: "type", label: "نوع" },
      ],
      exchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "date", label: "تاریخ" },
      ],
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      isBusy2: false,
      TotalRows: 1,
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
    };
  },

  methods: {
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.allTotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    openChangeInventoryDialog(item) {
      this.changeInventoryDialog = true;
      this.selected = item;
    },
    openEntryDialog() {
      this.entryDialog = true;
      this.entry = {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        time: moment(new Date()).format("HH:mm"),
      };
    },
    openExitDialog() {
      this.exitDialog = true;
      this.exit = {
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        time: moment(new Date()).format("HH:mm"),
      };
    },
    openTransferDialog() {
      this.transferDialog = true;
      this.transfer.to = "";
    },
    openEditDialog(item) {
      this.editDialog = true;
      this.selected2 = JSON.parse(JSON.stringify(item));
    },
    closeEditModal() {
      this.editDialog = false;
    },
    openNewItemDialog(item) {
      this.newItemDialog = true;
      this.selected = item.id;
      this.newItem = {};
    },
    openDetailDialog(item) {
      this.detailDialog = true;
      this.selected = item.id;
      this.getInfo();
    },
    getInfo() {
      this.isBusy2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/getInfo",
        {
          warehouseItemId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy2 = false;
          if (res.status == 200) {
            this.info = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy2 = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    entrySubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/entrance",
        {
          warehouseItemId: this.selected.id,
          warehouseId: this.entry.warehouse,
          amount: this.entry.number,
          date: this.entry.date + " " + this.entry.time,
          orgDes: this.entry.origin,
          note: this.entry.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.entryDialog = false;
            this.entry = {};
            this.getItems();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    exitSubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/exit",
        {
          warehouseItemId: this.selected.id,
          warehouseId: this.exit.warehouse,
          amount: this.exit.number,
          date: this.exit.date + " " + this.exit.time,
          orgDes: this.exit.origin,
          note: this.exit.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.exitDialog = false;
            this.exit = {};
            this.getItems();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    transferSubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/transfer",
        {
          warehouseItemId: this.selected.id,
          warehouseSectionId: this.transfer.to,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.transferDialog = false;
            this.getItems();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addItem() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/new",
        {
          warehouseTypeId: this.type.id,
          name: this.newItem.name,
          identifierFa: this.newItem.identifierFa,
          identifierEn: this.newItem.identifierEn,
          description: this.newItem.description,
          technicalDescription: this.newItem.technicalDescription,
          material: this.newItem.material,
          coating: this.newItem.coating,
          dimensionStandard: this.newItem.dimensionStandard,
          diameter: this.newItem.diameter,
          length: this.newItem.length,
          place: this.newItem.place,
          suppliersList: this.newItem.suppliersList,
          expireDate: this.newItem.expireDate,
          measurementUnit: this.newItem.measurementUnit,
          alertRange: this.newItem.alertRange,
          crisisRange: this.newItem.crisisRange,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newItemDialog = false;
            this.getItems();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    editItem() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/edit",
        {
          warehouseItemId: this.selected2.id,
          name: this.selected2.name,
          identifierFa: this.selected2.identifierFa,
          identifierEn: this.selected2.identifierEn,
          description: this.selected2.description,
          technicalDescription: this.selected2.technicalDescription,
          material: this.selected2.material,
          coating: this.selected2.coating,
          dimensionStandard: this.selected2.dimensionStandard,
          diameter: this.selected2.diameter,
          length: this.selected2.length,
          place: this.selected2.place,
          suppliersList: this.selected2.suppliersList,
          expireDate: this.selected2.expireDate,
          measurementUnit: this.selected2.measurementUnit,
          alertRange: this.selected2.alertRange,
          crisisRange: this.selected2.crisisRange,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editDialog = false;
            this.check.name = false;
            this.check.material = false;
            this.check.coating = false;
            this.check.standard = false;
            this.check.diameter = false;
            this.check.length = false;
            this.check.number = false;
            this.check.description = false;
            this.getItems();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getItems() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItems/warehouseTypeId",
        {
          warehouseTypeId: this.type.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.items = res.data;
            this.TotalRows = this.items.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getWarehouses() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouses/getByType",
        {
          warehouseTypeId: this.type.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.warehouses = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },

  mounted() {
    this.getWarehouses();
    this.getItems();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.nav-pills {
  padding: 10px !important;
}
.changeInventory-btn {
  display: flex;
  align-items: center;
  flex-flow: column;
}
</style>
